import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Nav from './Nav'
import PreFooter from './PreFooter'
import Footer from './Footer'

// * FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faCheckCircle,
	faClock,
	faCalendarAlt,
	faCheck,
	faPhone,
	faMobileAlt,
	faMapMarker,
	faEnvelope,
	faComment,
	faCamera,
	faExclamationTriangle,
	faUser,
	faCube,
	faSwimmingPool,
	faChevronDown,
	faMapMarkedAlt,
	faRobot,
	faFlask,
	faStickyNote,
	faPenSquare,
	faInfoCircle,
	faShoppingCart,
	faCopyright,
} from '@fortawesome/free-solid-svg-icons'
import {
	faFacebookF,
	faMailchimp,
	faTwitter,
	faInstagram,
	faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'
library.add(
	faFacebookF,
	faMailchimp,
	faTwitter,
	faInstagram,
	faLinkedinIn,
	faCheckCircle,
	faClock,
	faCalendarAlt,
	faCheck,
	faPhone,
	faMobileAlt,
	faMapMarker,
	faEnvelope,
	faComment,
	faCamera,
	faExclamationTriangle,
	faUser,
	faCube,
	faSwimmingPool,
	faChevronDown,
	faMapMarkedAlt,
	faRobot,
	faFlask,
	faStickyNote,
	faPenSquare,
	faInfoCircle,
	faShoppingCart,
	faCopyright
)

import './index.scss'

const Layout = ({ children }) => (
	<StaticQuery
		query={graphql`
			query SiteTitleQuery {
				site {
					siteMetadata {
						title
					}
				}
			}
		`}
		render={data => (
			<div className="Layout">
				<Helmet
					title={data.site.siteMetadata.title}
					meta={[
						{ name: 'description', content: 'Book your FREE Demo today!' },
						{
							name: 'keywords',
							content: 'demo, dolphin, robot, free, book, booking',
						},
					]}
				>
					<html lang="en" />
				</Helmet>
				<Nav />
				<section className="Children">{children}</section>
				<PreFooter />
				<Footer />
			</div>
		)}
	/>
)

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}

export default Layout
